module.exports = __webpack_public_path__ + "img/changeStonegroup-1@2x.a95614b.png";